import React, { useState } from "react";
import Navbar from "./Navbar";

const faqs = [
  {
    section: "About Forge SA",
    questions: [
      {
        q: "What is Forge SA?",
        a: "Forge SA is a South African community investment platform where ordinary South Africans pool their contributions to fund and build real community projects that create jobs, improve infrastructure, and restore dignity to communities that have been left behind. It is not a charity, not a government programme, and not another promise. It is a transparent, community-owned system built by South Africans for South Africans.",
      },
      {
        q: "Is Forge SA a charity?",
        a: "No. Forge SA is not a charity and does not operate like one. When you contribute to Forge SA you are not giving money away, you are investing in something that will benefit your community directly and permanently. The people who fund a project are the same people who benefit from it. That is not charity. That is ownership.",
      },
      {
        q: "Is Forge SA a government programme?",
        a: "No. Forge SA has no affiliation with any government department, political party, or government agency. It is an independent, community-driven platform. No outside interest owns it, controls it, or benefits from it.",
      },
      {
        q: "What makes Forge SA different from GoFundMe or BackaBuddy?",
        a: "Those platforms collect money and trust the recipient to use it correctly. There is no verification, no staged releases, and no independent oversight. Forge SA never releases money to any individual. Funds go directly to verified suppliers, cooperatives, and workers, in stages, with proof, governed by Forge Vault's rules, and with every transaction publicly logged. The difference is accountability.",
      },
      {
        q: "What makes Forge SA different from a stokvel?",
        a: "A stokvel pools money and pays it back to members at the end of a cycle. Forge SA pools money and builds something permanent that keeps paying the community forever. A stokvel ends. What Forge SA builds does not.",
      },
      {
        q: "Is Forge SA only for certain South Africans?",
        a: "No. Forge SA is for every South African regardless of age, province, education level, income, or background. You do not need to be employed. You do not need a university degree. You do not need to live in a city. If you are South African and you believe things can be better, you belong here.",
      },
      {
        q: "Why is it called Forge SA?",
        a: "The word forge means to create something strong by applying heat and pressure. A blacksmith forges metal, he takes raw material that seems ordinary, applies intense force and fire, and creates something powerful, durable, and useful. That is exactly what Forge SA does with South Africa's greatest resource, its people. SA stands for South Africa because this platform is proudly, unapologetically South African. Built here. For here. By us.",
      },
    ],
  },
  {
    section: "Your Money",
    questions: [
      {
        q: "What is Forge Vault?",
        a: "Forge Vault is Forge SA's governance process. It is the system that decides when money can move, checking a fixed set of rules automatically before any payment is released, including whether the funding goal has been reached, the supplier is verified, the invoice matches the approved budget, and the required evidence has been submitted. No individual can bypass it or override it.",
      },
      {
        q: "How much does Forge SA charge me?",
        a: "Nothing. Individual contributors pay zero fees, ever. Every rand you contribute goes directly to the project. Forge SA never deducts processing fees, platform fees, or any other charges from your contribution.",
      },
      {
        q: "So how does Forge SA make money?",
        a: "Forge SA sustains itself through a modest percentage absorbed by each project from total funds raised, higher fees charged to independently owned Tier 2 projects, and corporate access fees paid by companies using the Forge SA talent database. Your contribution is never touched.",
      },
      {
        q: "How do I know my payment is secure?",
        a: "All payments on Forge SA are processed through PayFast, one of South Africa's most trusted and widely used payment platforms. Forge SA never stores your card details. Every transaction is encrypted and secure.",
      },
      {
        q: "Will I receive proof of my contribution?",
        a: "Yes. Every contributor receives an automated receipt immediately after their contribution is processed. You can also view your full contribution history at any time from your personal dashboard.",
      },
      {
        q: "Can I contribute anonymously?",
        a: "Yes. You can choose to make your contribution anonymously. Your name will not appear publicly on the project page. Your contribution will still be tracked and protected, anonymity affects visibility only, not security.",
      },
      {
        q: "Can I contribute from outside South Africa?",
        a: "Yes. Any person anywhere in the world who believes in building South Africa can contribute to Forge SA. International contributions are processed through PayFast's international payment gateway. All funds are held in South African rand and managed under South African financial regulations. If you are a South African living abroad, this is your chance to invest in the country you came from without being physically present.",
      },
      {
        q: "Can businesses and companies contribute to projects?",
        a: "Yes. Businesses can contribute to any Forge SA project. Corporate contributions are welcome and treated with the same transparency and accountability as individual contributions. Companies looking to fulfil their Corporate Social Investment obligations will find Forge SA's verified, transparent model ideal, every rand is tracked publicly and impact reports are available for compliance and reporting purposes.",
      },
      {
        q: "What is the difference between contributing and donating?",
        a: "When you donate you give money and expect nothing back. When you contribute on Forge SA you are investing in something that will benefit your community directly and permanently. The people who contribute are the same people who benefit from what gets built, through jobs created, infrastructure improved, and communities strengthened. You are not a donor. You are a builder.",
      },
    ],
  },
  {
    section: "Projects",
    questions: [
      {
        q: "Who approves fund releases?",
        a: "No individual approves a fund release, Forge Vault does. The Project Lead submits a payment request with evidence that a milestone has been completed. Forge Vault automatically verifies every governance rule, including supplier verification, approved budget, and supporting evidence. Once every condition is satisfied, payment is released directly to the verified supplier or worker. If any rule fails, the payment is automatically paused until the issue is resolved.",
      },
      {
        q: "How do I know a project is real and not fake?",
        a: "Every project on Forge SA goes through a rigorous verification process before going live. The project creator's ID number is checked and validated. Project creators go through a background review before approval. The project plan and budget are independently reviewed. An advisory panel assesses viability. Community members vote before the project is approved. Additionally every milestone must be proven with real evidence before any funds are released, making it structurally impossible to collect money for a fake project.",
      },
      {
        q: "Can I contribute to multiple projects at once?",
        a: "Yes. You can contribute to as many projects as you want simultaneously. Each contribution is tracked separately and you will receive individual impact updates for every project you support. Your dashboard shows all your contributions in one place.",
      },
      {
        q: "What happens if a project fails?",
        a: "If a project fails Forge SA flags it immediately and notifies all contributors. Remaining funds are frozen. Contributors vote on next steps, pivot the project, find new management, or close it. If closure is chosen remaining funds return to the Forge SA community fund and are directed toward the next verified project. A full public report is published explaining exactly what happened and what was done with every rand. Nothing disappears.",
      },
      {
        q: "What happens if fraud is suspected?",
        a: "All related funds are frozen immediately by Forge Vault. An independent investigation is launched. Anyone involved is suspended pending investigation. A full public transparency report is published. Legal action is pursued against anyone found responsible.",
      },
      {
        q: "Can I see where my money went?",
        a: "Yes, completely and at any time. Every transaction on Forge SA is recorded on a public ledger visible to anyone without needing to log in. You can see every contribution received, every deposit confirmed, every fund release, every supplier payment, and every salary paid. You do not have to trust Forge SA. You can verify everything yourself.",
      },
      {
        q: "How are workers on Forge SA projects paid?",
        a: "Every worker is registered with a verified ID and banking details. Payroll is verified by Forge Vault and released directly from the project's bank account to each worker's verified account. No cash payments ever. Once a project is fully operational and generating its own income the business manages its own payroll independently. However every project signs a legally binding profit-sharing agreement where a percentage of monthly profits returns to the Forge SA community fund to seed the next project.",
      },
      {
        q: "What happens to jobs after a project is complete?",
        a: "Jobs created by Forge SA projects are permanent, not temporary construction work that disappears when the building is done. Once a cooperative or business is built and operational it employs people indefinitely and manages its own staffing independently. A percentage of profits returns to the Forge SA community fund to seed the next project, creating a cycle where every completed project helps create more permanent jobs through the next one.",
      },
      {
        q: "Are projects only for certain provinces?",
        a: "No. Forge SA projects are open to every province in South Africa. Contributors from any province can fund any project nationally. Projects can be proposed from any province. Forge SA's vision is a South Africa where every province thrives.",
      },
      {
        q: "What types of projects does Forge SA fund?",
        a: "Forge SA funds projects across multiple categories including Jobs and Opportunity, Infrastructure, Education, Housing, Agriculture, Water and Sanitation, Arts and Culture, and Science and Innovation. Both large national projects and smaller community-specific projects are welcome.",
      },
      {
        q: "What projects will never be approved?",
        a: "Projects affiliated with any political party or religious institution. Projects that benefit only one family or individual. Projects with no demonstrable community impact. Projects with unrealistic or unverifiable budgets. Projects where a single person retains control of funds or decisions. Duplicate projects already operating in the same area. Projects proposed by individuals or groups with a history of fraud.",
      },
      {
        q: "How do I track the impact of my contribution?",
        a: "Every contributor receives a personal impact tracker in their dashboard. It shows every project you have contributed to, the current milestone status, proof of progress including photographs and reports, and a running total of the jobs your contributions have helped create.",
      },
      {
        q: "How do I report a suspicious project?",
        a: "Email your concern directly to hello@forge-sa.co.za and Forge SA's oversight team will investigate. If the concern is serious, funds are frozen immediately pending investigation.",
      },
    ],
  },
  {
    section: "Starting a Project",
    questions: [
      {
        q: "Can I start my own project on Forge SA?",
        a: "Yes. Forge SA has two types of projects. Tier 1 Official Projects are national projects governed by Forge SA. Tier 2 Independent Community Projects belong to the group that creates them, Forge SA provides the trusted infrastructure while the group retains ownership of what is built.",
      },
      {
        q: "What is the difference between Tier 1 and Tier 2?",
        a: "Tier 1 projects are national, community-wide initiatives where Forge SA holds the assets as custodian on behalf of the community. Tier 2 projects are independently owned, your group proposes, builds, and owns what gets created. Forge SA provides the trusted infrastructure, verification, and fund protection while the group retains full ownership of the outcome.",
      },
      {
        q: "What do I need to start a Tier 2 project?",
        a: "Your group must have a minimum of three members, all registered and verified on Forge SA. All members must pass a background review. The group must register as a formal legal entity such as a cooperative or PTY Ltd. You must submit a detailed project plan, a realistic budget, a land or premises plan, a plan for profit management, and a signed group agreement. Applications are reviewed within 5 to 7 working days.",
      },
      {
        q: "How long does project approval take?",
        a: "Tier 2 project applications are reviewed within 5 to 7 working days from the date all required documents are submitted. Incomplete applications will be returned with a list of what is missing. Forge SA will not approve any project that does not meet the full verification criteria, no exceptions.",
      },
      {
        q: "How do I propose a project?",
        a: "Log in to your Forge SA account, go to your dashboard, and click Propose a Project. You will be guided through a step-by-step application form. Make sure you have all required documents ready before you begin.",
      },
      {
        q: "What happens after I submit a project proposal?",
        a: "You will receive a confirmation that your application was received. Forge SA will review your documents within 5 to 7 working days. You will be notified of the outcome, approved, returned for additional information, or declined with a clear reason. Approved projects go to community voting before going live.",
      },
    ],
  },
  {
    section: "General Questions",
    questions: [
      {
        q: "Is my personal information safe?",
        a: "Yes. Forge SA is built with data protection in mind, in line with South Africa's Protection of Personal Information Act (POPIA). Your personal information, including your ID number, banking details, and contact information, is only ever used for verification purposes and is never sold or shared with third parties without your consent.",
      },
      {
        q: "Can I use Forge SA on my phone?",
        a: "Yes. Forge SA is fully optimised for mobile use. You can browse projects, contribute, track your impact, and manage your account entirely from your smartphone, no app download required. Simply visit forge-sa.co.za on your phone's browser and everything works seamlessly.",
      },
      {
        q: "What is the Forge SA talent database?",
        a: "The Forge SA talent database is a verified directory of South African job seekers across every profession and skill level. When a Forge SA funded project creates jobs it hires directly from this database prioritising local community members first. Corporate partners also pay to access this database to find verified, skilled South Africans for their own hiring needs. Registering on the talent database is free for all Forge SA members.",
      },
      {
        q: "Can I volunteer my skills to a Forge SA project instead of contributing money?",
        a: "Yes. Forge SA's talent database allows you to register your skills, qualifications, and availability. When a funded project needs people, whether teachers, engineers, nurses, administrators, or cleaners, it draws directly from this database. Contributing your skills is just as valuable as contributing your money. Both build South Africa.",
      },
      {
        q: "Once a project is operational does Forge SA still have any involvement?",
        a: "Yes but in a limited and non-intrusive way. Once a project is operational Forge SA's role shifts from financial overseer to accountability partner. The business runs itself independently. Forge SA's only ongoing involvement is ensuring the legally binding profit-sharing agreement is honoured. The business submits an annual financial report to Forge SA for transparency purposes and contributors receive an annual impact report showing what their contribution built and what it continues to generate.",
      },
    ],
  },
];

const badgeColors = [
  { bg: "rgba(27,58,107,0.07)", border: "rgba(27,58,107,0.15)", color: "#1B3A6B" },
  { bg: "rgba(201,168,76,0.1)", border: "rgba(201,168,76,0.3)", color: "#8a6a1a" },
  { bg: "rgba(46,125,50,0.08)", border: "rgba(46,125,50,0.2)", color: "#2E7D32" },
  { bg: "rgba(91,155,213,0.1)", border: "rgba(91,155,213,0.3)", color: "#185FA5" },
  { bg: "rgba(192,57,43,0.07)", border: "rgba(192,57,43,0.2)", color: "#C0392B" },
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggle = (sectionIndex, questionIndex) => {
    const key = `${sectionIndex}-${questionIndex}`;
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>
      <style>{`
        .faq-header { padding: 56px 48px 48px; }
        .faq-main { max-width: 860px; margin: 0 auto; padding: 48px 48px 72px; }
        .faq-item { background: #fff; border: 1px solid #EDE8DF; border-radius: 14px; margin-bottom: 10px; overflow: hidden; }
        .faq-question { display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; cursor: pointer; gap: 16px; }
        .faq-question-text { font-size: 15px; font-weight: 700; color: #1A1A2E; line-height: 1.4; }
        .faq-answer { padding: 0 22px 20px; font-size: 14px; color: #4A4A6A; line-height: 1.85; }
        .faq-chevron { flex-shrink: 0; transition: transform 0.2s; }
        .faq-chevron-open { flex-shrink: 0; transition: transform 0.2s; transform: rotate(180deg); }
        .faq-section-badge { display: inline-block; border-radius: 99px; padding: 5px 16px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 20px; }
        @media (max-width: 768px) {
          .faq-header { padding: 36px 20px 32px; }
          .faq-main { padding: 32px 20px 48px; }
          .faq-question { padding: 16px 18px; }
          .faq-question-text { font-size: 14px; }
          .faq-answer { padding: 0 18px 16px; }
        }
      `}</style>

      <Navbar />

      <div className="faq-header" style={{ background: "#fff", borderBottom: "1px solid #EDE8DF", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          FAQ
        </div>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: 900, color: "#1A1A2E", letterSpacing: "-0.02em", margin: "0 0 16px", lineHeight: 1.1 }}>
          Frequently Asked <span style={{ color: "#1B3A6B" }}>Questions</span>
        </h1>
        <p style={{ fontSize: 15, color: "#888", lineHeight: 1.8, maxWidth: 560, margin: "0 auto" }}>
          Everything you need to know about Forge SA, answered honestly and completely.
        </p>
      </div>

      <div className="faq-main">
        {faqs.map((section, sectionIndex) => {
          const badge = badgeColors[sectionIndex % badgeColors.length];
          return (
            <div key={sectionIndex} style={{ marginBottom: 48 }}>
              <div
                className="faq-section-badge"
                style={{ background: badge.bg, border: `1px solid ${badge.border}`, color: badge.color }}
              >
                {section.section}
              </div>
              {section.questions.map((item, questionIndex) => {
                const key = `${sectionIndex}-${questionIndex}`;
                const isOpen = !!openItems[key];
                return (
                  <div key={questionIndex} className="faq-item">
                    <div className="faq-question" onClick={() => toggle(sectionIndex, questionIndex)}>
                      <div className="faq-question-text">{item.q}</div>
                      <svg
                        className={isOpen ? "faq-chevron-open" : "faq-chevron"}
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#888"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </div>
                    {isOpen && (
                      <div className="faq-answer">{item.a}</div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}

        <div style={{ background: "#1B3A6B", borderRadius: 20, padding: "40px 48px", textAlign: "center" }}>
          <h2 style={{ fontSize: 24, fontWeight: 900, color: "#fff", marginBottom: 12, letterSpacing: "-0.01em" }}>
            Still have questions?
          </h2>
          <p style={{ color: "rgba(184,212,232,0.8)", fontSize: 15, marginBottom: 20, lineHeight: 1.7 }}>
            We believe in complete transparency, including about things we have not answered here. Contact us directly and we will respond within 24 hours.
          </p>
          <div
            onClick={() => window.location.href = "mailto:hello@forge-sa.co.za"}
            style={{ display: "inline-block", background: "#C9A84C", borderRadius: 99, padding: "13px 28px", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}
          >
            hello@forge-sa.co.za
          </div>
          <div style={{ marginTop: 20, fontSize: 12, color: "rgba(184,212,232,0.35)" }}>
            Every rand. Fully protected. Fully transparent. Always.
          </div>
        </div>
      </div>
    </div>
  );
}